import React, { useEffect } from 'react';
import { EditIcon } from 'components';
import FEED_KEYWORDS from 'core/keywords';
import { WAREHOUSE_SERIES_CONTROL_SCREEN_KEY } from 'core/ScreenBuilder/screenKeys';
import { useWarehouseSeriesControl } from './WarehouseSeriesControlContext';

export const canShowWarehouseSeriesControlAction = ({
	screenKey,
	datasourceStatus,
	datasourceSingleData,
}) =>
	screenKey === WAREHOUSE_SERIES_CONTROL_SCREEN_KEY &&
	datasourceStatus === FEED_KEYWORDS.STATUS.SUCCESS &&
	datasourceSingleData?.canChangeSeriesState === true;

const WarehouseSeriesControlToolbarAction = props => {
	const { isEditMode, isSubmitting, reset, toggleEditMode } =
		useWarehouseSeriesControl();
	const canShow = canShowWarehouseSeriesControlAction(props);

	useEffect(() => {
		if (!canShow) reset();
	}, [canShow, reset]);

	if (!canShow) return null;

	const label = isEditMode
		? 'Salir del cambio de estado de series'
		: 'Cambiar estado de series';

	return (
		<span title={label}>
			<EditIcon
				aria-label={label}
				onClick={() => {
					if (!isSubmitting) toggleEditMode();
				}}
			/>
		</span>
	);
};

export default WarehouseSeriesControlToolbarAction;
